import { Person } from "@b2bportal/air-booking-api";
import { Assistance, Gender, IPerson } from "redmond";

export const personToIPerson = (person: Person): IPerson => ({
  ...person,
  gender: Gender[person.gender],
  assistance: person.assistance.map((assistance) => Assistance[assistance]),
});
